import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useAllowFeature } from "./useAllowFeature";
import { useTypedFlags } from "./useTypedFlags";

export function useCanUseConsolidation(): boolean {
    const { consolidation: isConsolidationFlagEnabled } = useTypedFlags();
    const { hasAccess: hasConsolidationPlan } = useAllowFeature(
        PREMIUM_FEATURES.CONSOLIDATION,
    );

    return isConsolidationFlagEnabled && hasConsolidationPlan;
}
